export default __webpack_public_path__ + "static/media/logoblue.19dbb9f1.svg";